import { render, staticRenderFns } from "./Mobilephone.vue?vue&type=template&id=03b800e2&scoped=true"
import script from "./Mobilephone.vue?vue&type=script&lang=ts"
export * from "./Mobilephone.vue?vue&type=script&lang=ts"
import style0 from "./Mobilephone.vue?vue&type=style&index=0&id=03b800e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b800e2",
  null
  
)

export default component.exports